export default __webpack_public_path__ + "static/our-story-group@2x-5b5000458a160bf7ab06f31eb1f3db49.jpg";